var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.js_sliderHero');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        fade: true,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        appendArrows: $(".slider--hero .arrows"),
        prevArrow: '<i class="icon icon-prev"></i>',
        nextArrow: '<i class="icon icon-next"></i>',
    }); 
}


// Slider - Artists
//-----------------------------------------------------------------
mp.sliderArtists = function() {
    var $slider = $('.js_sliderArtists');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        fade: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
    });

    $('.js_sliderArtists').on('beforeChange', function(event) {
        mp.stickySidebar();
    });
}


// Slider - Partners
//-----------------------------------------------------------------
mp.sliderPartners = function() {
    var $slider = $('.js_sliderPartners');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        mobileFirst: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            }
        ]
    }); 
}




$(document).ready(function (){
    mp.sliderHero();
    mp.sliderArtists();
    mp.sliderPartners();
});